// lib/slides/reviewEvidence.ts
import type { SlideReviewRun } from '#types/types';

// Capture and approved reuse have independent kill switches. The optional capture
// restriction is separate from the permanent QA-reference exclusion.
export const SLIDES_LEARNING_ENABLED: boolean = true;
export const SLIDES_REVIEW_EVIDENCE_ENABLED: boolean = true;
export const SLIDES_REVIEW_EVIDENCE_QA_PROJECT_ID: string | null = null;

export const SLIDES_EVIDENCE_PREFIX = 'SLIDES_REVIEW_EVIDENCE_';
export const SLIDES_EVIDENCE_ID_PREFIX = 'slrev-';

export const isSlidesEvidenceType = (value: unknown): boolean =>
  typeof value === 'string' && value.startsWith(SLIDES_EVIDENCE_PREFIX);

export const isSlidesEvidenceId = (value: unknown): boolean =>
  typeof value === 'string' && value.startsWith(SLIDES_EVIDENCE_ID_PREFIX);

export function isCapturedReviewRun(value: unknown): value is SlideReviewRun & { evidenceVersion: 1 } {
  if (!value || typeof value !== 'object') return false;
  const run = value as SlideReviewRun;
  return run.evidenceVersion === 1 &&
    [run.id, run.projectId, run.sessionId].every((id) => typeof id === 'string' && id.length > 0 && id.length <= 200) &&
    Number.isSafeInteger(run.round) && run.round > 0 &&
    ['running', 'completed', 'incomplete', 'stopped', 'failed'].includes(run.status) &&
    typeof run.startedAt === 'string' && Number.isFinite(Date.parse(run.startedAt)) &&
    (run.brief === undefined || typeof run.brief === 'string') &&
    (run.userEdited === undefined || typeof run.userEdited === 'boolean') &&
    (run.agentMutationCount === undefined || (Number.isSafeInteger(run.agentMutationCount) && run.agentMutationCount >= 0));
}
